import { WorkspaceBundle } from '@adminhub/graphql-types';

import type { CollectionConfigMapJson } from '../types/collection-config-schema';
import { EnterpriseCollectionPackageType } from '../types/collection-config-types';

export const config: CollectionConfigMapJson = {
  collections: {
    '3e6f105a-4f6d-44d1-8716-7e9468544d93': {
      productId: '3e6f105a-4f6d-44d1-8716-7e9468544d93',
      type: WorkspaceBundle.StrategyCollection,
    },
    '3503c251-c247-4b55-a6ed-d4c8c3257b8b': {
      productId: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
      type: WorkspaceBundle.TeamworkCollection,
      enterpriseCollectionPackageType: EnterpriseCollectionPackageType.EnterpriseTeamworkCollection,
      // TODO: Replace with offersEnterpriseAppsDeterminant: true when FG is fully rolled out
      offersEnterpriseAppsDeterminant: 'enterprise-collection-apps-onboarding-refactor',
      childProductIds: [
        '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        '7683a73e-423d-41a1-b43f-d497656f8b5d',
      ],
    },
    '9af73c36-bb77-41f8-9b11-2d20e9f74c44': {
      productId: '9af73c36-bb77-41f8-9b11-2d20e9f74c44',
      type: WorkspaceBundle.ServiceCollection,
      // TODO: PHIRE-1731 Onboard JSM and CSM enterprise collection offerings
    },
  },
};
